// Where to go once signed in: the page a signed-out user opened (an emailed link such as a card request
// to approve, or a bookmark), kept in sessionStorage across the sign-in. Only a page of the same site,
// never its home or login pages, so a sign-in without one still lands on home.
const KEY = 'returnTo';

export const saveReturnTo = (site) => {
	try {
		const path = window.location.pathname + window.location.search;
		const base = `/${site}`;
		if (!path.toLowerCase().startsWith(base + '/'))
			return;
		const rest = path.slice(base.length).toLowerCase();
		if (rest === '/' || rest.startsWith('/home') || rest.startsWith('/login'))
			return;
		sessionStorage.setItem(KEY, JSON.stringify({ site, path }));
	} catch { /* storage unavailable: the sign-in lands on home */ }
};

// The saved page for this site, once (it is cleared), or null.
export const takeReturnTo = (site) => {
	try {
		const raw = sessionStorage.getItem(KEY);
		sessionStorage.removeItem(KEY);
		const saved = raw ? JSON.parse(raw) : null;
		if (saved && saved.site === site && typeof saved.path === 'string' && saved.path.startsWith(`/${site}/`))
			return saved.path;
	} catch { /* storage unavailable */ }
	return null;
};
